module.exports = __webpack_public_path__ + "static/bone_devil-8ab6e5c936dd18247aa36f5f1666deed.jpg";